export default [
    {
        path: 'referenciamentos/:id',
        component: require('./Read').default,
        meta: { middleware: 'auth', controller: 'ReferenciaController' }
    },
    // {
    //     path: 'referenciamentos/edit/:id',
    //     component: require('./Edit').default,
    //     meta: { middleware: 'auth', controller: 'ReferenciaController' },
    // },
    {
        path: 'referenciamentos/show/:id',
        component: require('./Show').default,
        meta: {
            middleware: 'auth',
            controller: 'ReferenciaController'
        }
    },
    {
        path: 'referenciamentos/show/:id/devolutiva',
        component: require('./AddDevolutiva').default,
        meta: {
            middleware: 'auth',
            controller: 'ReferenciaController'
        }
    },

    {
        path: 'relatorios/referenciamentos',
        component: require('./reports/Reports').default,
        redirect: 'relatorios/referenciamentos/home',
        meta: { middleware: 'auth', controller: 'RelatorioReferenciamentoController' },
        children: [{
            path: 'home',
            name: 'relatorios_home_referenciamentos',
            component: require('./reports/includes/Home').default,
            meta: { middleware: 'auth', controller: 'RelatorioReferenciamentoController' },
        }, {
            path: 'graficos',
            name: 'graficos_referenciamentos',
            component: require('./reports/includes/Graficos').default,
            meta: { middleware: 'auth', controller: 'RelatorioReferenciamentoController' },
        }
        ]
    }
];
